import { render, staticRenderFns } from "./SalesReportMaterial.vue?vue&type=template&id=412f5400"
import script from "./SalesReportMaterial.vue?vue&type=script&lang=js"
export * from "./SalesReportMaterial.vue?vue&type=script&lang=js"
import style0 from "./SalesReportMaterial.vue?vue&type=style&index=0&id=412f5400&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports